import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-back-button',
    templateUrl: './back-button.component.html',
    styleUrls: ['./back-button.component.scss'],
    standalone: false
})
export class BackButtonComponent implements OnInit {

    @Input() defaultHref: string;

    constructor() {
    }

    ngOnInit(): void {
    }

}
